import axios from 'axios';
import Vue from 'vue';
import router from './../routes';
import store from './../store';

Vue.prototype.$http = axios.create({
  // baseURL: `http://127.0.0.1:8000/api/`,
  baseURL: `https://backend.origamiturismosistema.com.br/api/`,
  headers: {
    Authorization: `Bearer ${window.localStorage.getItem('client_origami_token')}`,
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  validateStatus: (status) => {
    if (status === 401 || status === 403) {
      store.commit('setUser', null);
      store.commit('setToken', null);
      window.localStorage.setItem('client_origami_user', null);
      window.localStorage.setItem('client_origami_token', null);
      router.push({'name': 'login'});
    }
    return status >= 200 && status < 300;
  },
});

if (window.localStorage && window.localStorage.getItem('client_origami_user') !== 'undefined') {
  if (store.state.user !== window.localStorage.getItem('client_origami_user')) {
    store.commit('setUser', JSON.parse(window.localStorage.getItem('client_origami_user')));
    store.commit('setToken', window.localStorage.getItem('client_origami_token'));
  }
}

Vue.prototype.$http.interceptors.request.use((config) => {
  return config;
}, (error) => {
  return Promise.reject(error);
});


// WEBPACK FOOTER //
// ./src/methods/api.js